import React from "react";
import { Paper } from "@mui/material";

const MessageBubble = ({
  messageContent,
  wrapperCssClasses,
}) => {
  return (
    <Paper className={wrapperCssClasses}>
      {messageContent}
    </Paper>
  )
}

export default MessageBubble;
